import * as Actions from '../actions/globalProvision.actions';

const initialState = {
    configurations: {
        data: [],
        total: 0,
        page: 1,
        limit: 10,
        totalPages: 0
    },
    currentConfiguration: null,
    executionLogs: {
        data: [],
        total: 0,
        page: 1,
        limit: 10,
        totalPages: 0
    },
    // Preview state for cluster creation form
    preview: {
        configs: [],
        matchedCount: 0,
        totalScripts: 0,
        loading: false,
        error: null
    },
    filter: {
        active: null,
        targetType: null,
        searchTerm: ''
    },
    loading: false,
    error: null
};

const globalProvisionReducer = (state = initialState, action) => {
    switch (action.type) {
        // Fetch Configurations
        case Actions.FETCH_CONFIGURATIONS_REQUEST: {
            return {
                ...state,
                loading: true,
                error: null
            };
        }
        case Actions.FETCH_CONFIGURATIONS_SUCCESS: {
            return {
                ...state,
                configurations: {
                    data: action.payload.data || action.payload.configurations || [],
                    total: action.payload.total || 0,
                    page: action.payload.page || 1,
                    limit: action.payload.limit || 10,
                    totalPages: action.payload.totalPages || 0
                },
                loading: false,
                error: null
            };
        }
        case Actions.FETCH_CONFIGURATIONS_FAILURE: {
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        }

        // Fetch Single Configuration
        case Actions.FETCH_CONFIGURATION_REQUEST: {
            return {
                ...state,
                loading: true,
                error: null
            };
        }
        case Actions.FETCH_CONFIGURATION_SUCCESS: {
            return {
                ...state,
                currentConfiguration: action.payload,
                loading: false,
                error: null
            };
        }
        case Actions.FETCH_CONFIGURATION_FAILURE: {
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        }

        // Create Configuration
        case Actions.CREATE_CONFIGURATION_REQUEST: {
            return {
                ...state,
                loading: true,
                error: null
            };
        }
        case Actions.CREATE_CONFIGURATION_SUCCESS: {
            return {
                ...state,
                currentConfiguration: action.payload,
                loading: false,
                error: null
            };
        }
        case Actions.CREATE_CONFIGURATION_FAILURE: {
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        }

        // Update Configuration
        case Actions.UPDATE_CONFIGURATION_REQUEST: {
            return {
                ...state,
                loading: true,
                error: null
            };
        }
        case Actions.UPDATE_CONFIGURATION_SUCCESS: {
            return {
                ...state,
                currentConfiguration: action.payload,
                loading: false,
                error: null
            };
        }
        case Actions.UPDATE_CONFIGURATION_FAILURE: {
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        }

        // Delete Configuration
        case Actions.DELETE_CONFIGURATION_REQUEST: {
            return {
                ...state,
                loading: true,
                error: null
            };
        }
        case Actions.DELETE_CONFIGURATION_SUCCESS: {
            return {
                ...state,
                configurations: {
                    ...state.configurations,
                    data: state.configurations.data.filter(config => config._id !== action.payload)
                },
                loading: false,
                error: null
            };
        }
        case Actions.DELETE_CONFIGURATION_FAILURE: {
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        }

        // Fetch Execution Logs
        case Actions.FETCH_EXECUTION_LOGS_REQUEST: {
            return {
                ...state,
                loading: true,
                error: null
            };
        }
        case Actions.FETCH_EXECUTION_LOGS_SUCCESS: {
            return {
                ...state,
                executionLogs: {
                    data: action.payload.data || action.payload.logs || [],
                    total: action.payload.total || 0,
                    page: action.payload.page || 1,
                    limit: action.payload.limit || 10,
                    totalPages: action.payload.totalPages || 0
                },
                loading: false,
                error: null
            };
        }
        case Actions.FETCH_EXECUTION_LOGS_FAILURE: {
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        }

        // UI Actions
        case Actions.CLEAR_CURRENT_CONFIGURATION: {
            return {
                ...state,
                currentConfiguration: null,
                error: null
            };
        }
        case Actions.SET_FILTER: {
            return {
                ...state,
                filter: {
                    ...state.filter,
                    ...action.payload
                }
            };
        }

        // Preview Matching Configs (for cluster form)
        case Actions.PREVIEW_MATCHING_CONFIGS_REQUEST: {
            return {
                ...state,
                preview: {
                    ...state.preview,
                    loading: true,
                    error: null
                }
            };
        }
        case Actions.PREVIEW_MATCHING_CONFIGS_SUCCESS: {
            return {
                ...state,
                preview: {
                    configs: action.payload.data || [],
                    matchedCount: action.payload.matchedCount || 0,
                    totalScripts: action.payload.totalScripts || 0,
                    loading: false,
                    error: null
                }
            };
        }
        case Actions.PREVIEW_MATCHING_CONFIGS_FAILURE: {
            return {
                ...state,
                preview: {
                    ...state.preview,
                    loading: false,
                    error: action.payload
                }
            };
        }
        case Actions.CLEAR_PREVIEW_CONFIGS: {
            return {
                ...state,
                preview: {
                    configs: [],
                    matchedCount: 0,
                    totalScripts: 0,
                    loading: false,
                    error: null
                }
            };
        }

        default: {
            return state;
        }
    }
};

export default globalProvisionReducer;
